if (!customElements.get('fs-bundle-discovery')) {
  customElements.define('fs-bundle-discovery', class extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.header-wrapper');
      this.header = this.closest('.section-header');
      this.drawer = this.wrapper?.querySelector('header-drawer');
      this.details = this.drawer?.querySelector(':scope > details');
      if (!this.header || !this.details) return;

      this.scheduleUpdate = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateDrawerHeight());
      };
      this.details.addEventListener('toggle', this.scheduleUpdate);
      window.addEventListener('resize', this.scheduleUpdate);
      if (typeof ResizeObserver !== 'undefined') {
        this.headerObserver = new ResizeObserver(this.scheduleUpdate);
        this.headerObserver.observe(this.header);
      }
      this.scheduleUpdate();
    }

    updateDrawerHeight() {
      if (!this.isConnected || !this.details.hasAttribute('open')) {
        this.restoreDrawerHeight();
        return;
      }
      if (this.previousOffset === undefined) {
        this.previousOffset = this.drawer.style.getPropertyValue('--header-bottom-position') || '';
        this.previousPriority = this.drawer.style.getPropertyPriority('--header-bottom-position');
      }
      const borderOffset = this.wrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      this.currentOffset = `${Math.trunc(this.header.getBoundingClientRect().bottom - borderOffset)}px`;
      this.drawer.style.setProperty('--header-bottom-position', this.currentOffset);
    }

    restoreDrawerHeight() {
      if (this.previousOffset === undefined) return;
      if (this.drawer.style.getPropertyValue('--header-bottom-position') === this.currentOffset) {
        if (this.previousOffset) {
          this.drawer.style.setProperty('--header-bottom-position', this.previousOffset, this.previousPriority);
        } else {
          this.drawer.style.removeProperty('--header-bottom-position');
        }
      }
      this.previousOffset = undefined;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.details?.removeEventListener('toggle', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      this.headerObserver?.disconnect();
      this.restoreDrawerHeight();
    }
  });
}
